.sn-cta-type-8 {
  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: map-get($spacings, xl);
    padding: map-get($spacings, 3xl) map-get($spacings, xl);
    text-align: center;
    border-radius: map-get($border-radii, lg);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, 5xl) map-get($spacings, 3xl);
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);
    max-width: 720px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: map-get($spacings, md);

    // On the stacked (mobile/tablet) layout, make every button the same width as
    // the widest one: stretch the actions to the column width (which shrink-wraps
    // to the widest button) and let each button fill that width.
    @include below-desktop {
      align-items: stretch;

      me-button .me-button {
        width: 100%;
      }

      // The demo-form primary is a button nested in sn-form-type-1: the wrapper
      // stretches as a flex item, but its inline-block trigger span and inline-flex
      // me-button host would otherwise shrink-wrap to the label, leaving the primary
      // narrower than the stretched secondary. Force the whole trigger chain to fill
      // the column (the modal — a sibling of the trigger — is left untouched).
      .sn-cta-type-8__demo-form,
      .sn-cta-type-8__demo-form .sn-form-type-1__trigger-wrap,
      .sn-cta-type-8__demo-form .sn-form-type-1__trigger-wrap me-button {
        width: 100%;
      }
    }

    @include above($breakpoint-desktop) {
      flex-direction: row;
      justify-content: center;
    }
  }
}

// ── Demo-form: reverse the visual button order ─────────────────────────────────
// With `demo-form`, the primary slot is the "Request a demo" modal trigger and
// must stay in `action-primary`. To show it AFTER the secondary button we reverse
// only the visual order (via `order`) — the DOM/slot assignment is unchanged, so
// the modal trigger still works.
sn-cta-type-8[demo-form] {
  .sn-cta-type-8__actions {
    .sn-cta-type-8__demo-form {
      order: 2;
    }

    [slot='action-secondary'] {
      order: 1;
    }
  }
}

// ── Dark variant (default) ────────────────────────────────────────────────────

sn-cta-type-8[variant='dark'] {
  .sn-cta-type-8__inner {
    background-color: $color-brand-primary-darkest;
    color: $color-neutral-white;
  }

  .me-heading {
    color: $color-neutral-white;
  }

  .me-text {
    color: $color-neutral-white;
    opacity: 0.85;
  }
}

// ── Light variant ─────────────────────────────────────────────────────────────

sn-cta-type-8[variant='light'] {
  .sn-cta-type-8__inner {
    background-color: $color-brand-primary-lightest;
    color: $color-neutral-black;
  }

  .me-heading {
    color: $color-neutral-black;
  }

  .me-button--bordered {
    --text-color-alternate: var(--text-color-primary);
    --border-color-alternate: var(--color-brand-primary-main);
  }
}
